import { render, staticRenderFns } from "./TipoUsoCadastro.vue?vue&type=template&id=f2a31a50&scoped=true&lang=html"
import script from "./TipoUsoCadastro.vue?vue&type=script&lang=js"
export * from "./TipoUsoCadastro.vue?vue&type=script&lang=js"
import style0 from "./TipoUsoCadastro.vue?vue&type=style&index=0&id=f2a31a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a31a50",
  null
  
)

export default component.exports